import { Tooltip } from 'components'
import { IconHands } from 'components/Icons'

interface TrackerScoreProps {
  readonly score: number | null
  readonly tooltip: string
}

const ICON_SIZE = 28
const ICON_COLOR = '#2D3748'

export const TrackerScore = ({ score, tooltip }: TrackerScoreProps) => {
  if (score == null || score <= 0) return null
  return (
    <Tooltip label={tooltip} multiline width={260} withArrow position='top'>
      <div role='img' aria-label={tooltip} style={{ display: 'inline-flex' }}>
        <IconHands value={score} width={ICON_SIZE} height={ICON_SIZE} color={ICON_COLOR} />
      </div>
    </Tooltip>
  )
}
